import _objectSpread from "@babel/runtime/helpers/objectSpread";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _inherits from "@babel/runtime/helpers/inherits";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import React from 'react';
import { getLocalText } from '@/utilities/language';
var defaultAnswer = {
  selected_values: [],
  selected_ids: [],
  type: 'cascader'
};
var LocChoice = /*#__PURE__*/function (_React$Component) {
  _inherits(LocChoice, _React$Component);
  function LocChoice() {
    var _getPrototypeOf2;
    var _this;
    _classCallCheck(this, LocChoice);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _possibleConstructorReturn(this, (_getPrototypeOf2 = _getPrototypeOf(LocChoice)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _defineProperty(_assertThisInitialized(_assertThisInitialized(_this)), "validator", function (rules, answer, callback) {
      var question = _this.props.question;
      if (question.required && answer.selected_values.length === 0) {
        callback(getLocalText('SingleChoice.Selected'));
        return;
      }
      callback();
    });
    return _this;
  }
  _createClass(LocChoice, [{
    key: "getSelectedChange",
    value: function getSelectedChange(optsText) {
      var _this$props$question = this.props.question;
      _this$props$question = _this$props$question === void 0 ? {} : _this$props$question;
      var _this$props$question$ = _this$props$question.custom,
        custom = _this$props$question$ === void 0 ? {} : _this$props$question$;
      var defaultOpts = (custom === null || custom === void 0 ? void 0 : custom.options) || [];
      var otherOptions = (custom === null || custom === void 0 ? void 0 : custom["".concat(window.language, "Options")]) || [];
      var _optsText = _slicedToArray(optsText, 3),
        fir = _optsText[0],
        sec = _optsText[1],
        third = _optsText[2];
      var options = window.showMultiLang ? otherOptions : defaultOpts;
      var ids = [];
      if (fir) {
        var firOpt = options.find(function (e) {
          return e.value === fir;
        });
        ids.push(firOpt.id);
        if (sec) {
          var secOpt = firOpt.children.find(function (e) {
            return e.value === sec;
          });
          ids.push(secOpt.id);
          if (third) {
            ids.push(secOpt.children.find(function (e) {
              return e.value === third;
            }).id);
          }
        }
      }
      return {
        type: 'cascader',
        selected_values: optsText,
        selected_ids: ids
      };
    }
  }, {
    key: "render",
    value: function render() {
      var _question$custom,
        _question$custom2,
        _question$custom3,
        _this2 = this;
      var _this$props = this.props,
        question = _this$props.question,
        _this$props$answer = _this$props.answer,
        answer = _this$props$answer === void 0 ? JSON.parse(JSON.stringify(defaultAnswer)) : _this$props$answer;
      var _this$props$form = this.props.form,
        getFieldProps = _this$props$form.getFieldProps,
        getFieldError = _this$props$form.getFieldError;
      var id = question.id || 'unknown-form-item';
      var _getFieldProps = getFieldProps(id, {
          initialValue: _objectSpread({}, answer),
          rules: [{
            required: true,
            validator: this.validator
          }]
        }),
        _onChange = _getFieldProps.onChange,
        formAnswer = _getFieldProps.value;
      var error = getFieldError(id);
      if (error && error.length > 0) error = error.join(',');else error = null;
      var options = ((_question$custom = question.custom) === null || _question$custom === void 0 ? void 0 : _question$custom.options) || [];
      var otherOptions = ((_question$custom2 = question.custom) === null || _question$custom2 === void 0 ? void 0 : _question$custom2["".concat(window.language, "Options")]) || [];
      var titles = question.custom.titles || [];
      var otherTitles = ((_question$custom3 = question.custom) === null || _question$custom3 === void 0 ? void 0 : _question$custom3["".concat(window.language, "Titles")]) || [];
      var params = {
        options: (window.showMultiLang ? otherOptions : options).filter(function (e) {
          return e;
        }),
        titles: window.showMultiLang ? otherTitles : titles,
        error: error,
        formAnswer: formAnswer,
        onChange: function onChange(val) {
          return _onChange(_this2.getSelectedChange(val));
        }
      };
      return this.props.children(params);
    }
  }]);
  return LocChoice;
}(React.Component);
export { LocChoice as default };